module.exports = __webpack_public_path__ + "static/media/app-store-icons.a1967cc6.jpeg";